<template>
  <div>
  </div>
</template>
<script>
export default {
  async created() {
    await this.$store.dispatch('idpRefreshCallback');
    this.$router.replace('/');
  },
};
</script>
